var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.986 12.886c0-2.228 1.33-4.142 2.992-4.142s2.99 1.913 2.99 4.142zM10.81 0H1.145a.69.69 0 0 0-.69.69v.46c0 .382.31.69.69.69 0 2.617 1.468 4.825 3.476 5.523-2.008.698-3.476 2.906-3.476 5.523a.69.69 0 0 0-.69.69v.46c0 .382.31.69.69.69h9.665a.69.69 0 0 0 .69-.69v-.46a.69.69 0 0 0-.69-.69c0-2.617-1.468-4.825-3.476-5.523 2.008-.698 3.476-2.906 3.476-5.522a.69.69 0 0 0 .69-.69V.69A.69.69 0 0 0 10.81 0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLoading);
export default __webpack_public_path__ + "static/media/status_loading.712b35c7.svg";
export { ForwardRef as ReactComponent };